module.exports = __webpack_public_path__ + "media/images/dashboards/vte-8982acd551a88b9c3698bda66d47f484.png";